
import { useState } from 'react';
import HiringModal from './HiringModal';

export default function Showcase() {
  const [isHiringOpen, setIsHiringOpen] = useState(false);

  return (
    <>
      <section id="work" className="py-24 lg:py-32 bg-[#fafafa]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="mb-8">
            <p className="text-xs uppercase tracking-[0.2em] text-gray-400 font-medium mb-4">
              Our People
            </p>
            <h2
              className="text-4xl lg:text-5xl font-bold text-gray-900 mb-8"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Our Team
            </h2>
          </div>

          <div className="max-w-3xl">
            <p
              className="text-lg lg:text-xl text-gray-600 leading-relaxed"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Cadence Studios is built by a talented team across the USA. We&apos;re always looking to hire and work with the best and
              brightest — if interested, get in touch through{' '}
              <button
                onClick={() => setIsHiringOpen(true)}
                className="inline font-semibold text-gray-900 underline underline-offset-4 decoration-gray-900/30 hover:decoration-gray-900 transition-all cursor-pointer whitespace-nowrap"
              >
                We&apos;re Hiring
              </button>
              .
            </p>
          </div>
        </div>
      </section>

      <HiringModal isOpen={isHiringOpen} onClose={() => setIsHiringOpen(false)} />
    </>
  );
}
